import { runtimeConfig } from "@/config/runtime"

export const ACCOUNT_TOKEN_KEY = "accountToken"
export const CUSTOMER_TOKEN_KEY = "customerToken"
export const SELECTED_CUSTOMER_ID_KEY = "selectedCustomerId"

function isHttps(): boolean {
  return window.location.protocol === "https:"
}

function getCookieDomain(): string | undefined {
  const fromQuery = new URLSearchParams(window.location.search).get("cookieDomain")
  if (fromQuery) {
    return fromQuery
  }

  if (runtimeConfig.authCookieDomain) {
    return runtimeConfig.authCookieDomain
  }

  const host = window.location.hostname
  if (host === "localhost" || host === "127.0.0.1") {
    return undefined
  }

  const parts = host.split(".")
  if (parts.length >= 2) {
    return `.${parts.slice(-2).join(".")}`
  }

  return undefined
}

function cookieSuffix(withDomain: boolean): string {
  const domain = withDomain ? getCookieDomain() : undefined
  let suffix = "; Path=/; SameSite=Lax"
  if (domain) {
    suffix += `; Domain=${domain}`
  }
  if (isHttps()) {
    suffix += "; Secure"
  }
  return suffix
}

function readCookie(name: string): string | null {
  const prefix = `${name}=`
  const match = document.cookie.split("; ").find((row) => row.startsWith(prefix))
  if (!match) {
    return null
  }

  return decodeURIComponent(match.slice(prefix.length)) || null
}

function writeCookie(name: string, value: string): void {
  document.cookie = `${name}=${encodeURIComponent(value)}${cookieSuffix(true)}`
}

function deleteCookie(name: string): void {
  const expired = `${name}=; Max-Age=0`
  document.cookie = `${expired}${cookieSuffix(true)}`
  document.cookie = `${expired}${cookieSuffix(false)}`
}

export function getAuthItem(key: string): string | null {
  return readCookie(key) || localStorage.getItem(key)
}

export function setAuthItem(key: string, value: string): void {
  localStorage.setItem(key, value)
  writeCookie(key, value)
}

export function removeAuthItem(key: string): void {
  localStorage.removeItem(key)
  deleteCookie(key)
}
